// Contact Form 7 送信完了後に /thanks/ へ遷移させる。
// CF7 の on_sent_ok は廃止のため、DOM イベント wpcf7mailsent を購読する方式。
// インライン JS 禁止のためモジュール化し、loading.js から呼び出す。
export function initCf7Redirect() {
  document.addEventListener(
    'wpcf7mailsent',
    () => {
      window.location.href = '/thanks/';
    },
    false
  );
}
